// extracted by mini-css-extract-plugin
export var layoutContainer = "_au-0";
export var layoutContainerNoRounding = "_au-6";
export var layoutContainerOpen = "_au-5";
export var layoutContainerResizing = "_au-1";
export var mainContent = "_au-2";
export var resizeDivider = "_au-3";
export var slidePanel = "_au-4";